import { render, staticRenderFns } from "./AggregateColumn.vue?vue&type=template&id=cd71e7b6&"
import script from "./AggregateColumn.vue?vue&type=script&lang=js&"
export * from "./AggregateColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports